import React, { useEffect, useState } from 'react'
import general from '../../general'
import { NavLink } from '../../lib/Navigation'
import Manager from '../components/Manager'
import Dialog from '../../lib/Dialog'

export default function MyChats(props) {

  return (
    <div>
      <div style={{padding:'10px 0'}}>
        <div style={{display:'flex',alignItems:'center',overflow:'scroll'}}>
          {props.items?.map(item=>{
            return (
              <NavLink key={item.game_id} to={'/game?id=' + item.game_id} style={{display:'flex',alignItems:'center',flex:'1 0 48%','textOverflow': 'ellipsis',
                        'overflow': 'hidden','whiteSpace': 'nowrap'}}>
                <img src={item.game_image.thumb} alt="" height={58} style={{borderRadius:'8px'}}/>
                <div style={{padding:'0 10px',overflow:"hidden"}}>
                  <div style={{fontSize:'15px',color:'#282828',fontWeight:'500',display:'flex',alignItems:'center'}}>
                    <div style={{textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',paddingBottom:'1px'}}>{item.game_name}</div>
                  </div>
                  <div style={{fontSize:'12px',color:'#999',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap'}}>
                  {item.game_classify_type.trim()}
                  </div>
                </div>
              </NavLink>
            )
          })}
        </div>
      </div>
    </div>
  )
}
